import Vue from 'vue';
import PluginsTemplate from '../pluginsTemplate';

import selectLocation from 'components/business/custom-form/select-location/index';
const SelectLocationConstructor = Vue.extend(selectLocation);

class SelectLocationPlugin extends PluginsTemplate {
  constructor() {
    super();
    this.defaults = {
      value: true,
    };
  }
  show(options = {}) {
    this.clearTimer();
    this.initPros(options);
    // 如果不存在实例 则初始化实例
    if (!this.instance) {
      let newInstance = new SelectLocationConstructor({
        el: document.createElement('div'),
      });
      this.initInstance(newInstance);
    }
    this.initDom();
  }
  close() {
    if (!this.instance) {
      return !1;
    }
    this.instance.value = false;
    this.clearTimer();
    this.timer = setTimeout(() => {
      this.removeInstance();
    }, 500);
  }
  initMethods() {
    // 选中事件处理
    this.instance.$off('selected-location');
    this.instance.$on('select-location', (result) => {
      this.props.onSelectedLocation && this.props.onSelectedLocation(result);
    });
    this.instance.$off('input');
    this.instance.$on('input', (value) => {
      if (!value) {
        this.close();
        this.props.onHide && this.props.onHide();
      }
    });
  }
}

let instance = new SelectLocationPlugin();

export default {
  show(params) {
    instance.show(params);
    return instance;
  },
  close() {
    instance.close();
  },
  install() {
    instance.install();
  },
};
